"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _constants = require("./assets/constants");
var _styles = require("./assets/styles");
var _utils = require("./assets/utils");
var _CancellationPolicyStage = _interopRequireDefault(require("./components/CancellationPolicyStage"));
var _CancellationStageListItem = _interopRequireDefault(require("./components/CancellationStageListItem"));
var _CollapsedCancellationPolicy = _interopRequireDefault(require("./components/CollapsedCancellationPolicy"));
var CancellationPolicyMobile = function CancellationPolicyMobile(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    data = props.data,
    isMobile = props.isMobile,
    insurancePrice = props.insurancePrice,
    _props$nowDateISO = props.nowDateISO,
    nowDateISO = _props$nowDateISO === void 0 ? new Date().toISOString() : _props$nowDateISO,
    _props$onGetInsurance = props.onGetInsuranceClick,
    onGetInsuranceClick = _props$onGetInsurance === void 0 ? function () {
      return null;
    } : _props$onGetInsurance,
    tooltipText = props.tooltipText,
    isCollapsed = props.isCollapsed,
    _props$onDetailsClick = props.onDetailsClick,
    onDetailsClick = _props$onDetailsClick === void 0 ? function () {
      return null;
    } : _props$onDetailsClick,
    _props$showBackground = props.showBackground,
    showBackground = _props$showBackground === void 0 ? true : _props$showBackground,
    isHotelOnly = props.isHotelOnly,
    insuranceSelected = props.insuranceSelected,
    _props$isMobilePopupC = props.isMobilePopupComponent,
    isMobilePopupComponent = _props$isMobilePopupC === void 0 ? false : _props$isMobilePopupC,
    mobileCollapsedElRef = props.mobileCollapsedElRef;
  var _data$stages = data.stages,
    stages = _data$stages === void 0 ? [] : _data$stages,
    flightDateISO = data.flight_date,
    _data$cancelated_at = data.cancelated_at,
    cancellationDateISO = _data$cancelated_at === void 0 ? undefined : _data$cancelated_at,
    description = data.description;
  var hasTooltip = Boolean(tooltipText);
  var hasInsurance = insurancePrice !== undefined;
  var gradient = (0, _utils.getFadeColors)(_constants.BASE_STAGE_COLOR, stages.length);
  var intervalledStages = (0, _utils.getIntervaledStages)(stages, flightDateISO, cancellationDateISO || nowDateISO);
  var currentStage = (0, _utils.getCurrentStage)(intervalledStages);
  var title = (0, _utils.getTitle)(currentStage, isHotelOnly);
  var currentReturnType = currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type;
  var fullReturn = (0, _utils.isFullReturn)(currentReturnType);
  var descriptionReturnType = (0, _utils.getReturnText)(currentStage === null || currentStage === void 0 ? void 0 : currentStage.refund_amount, currentStage.interval, fullReturn, isHotelOnly);
  var cancelled = (0, _utils.isCancelled)(cancellationDateISO);
  var TitleRow = /*#__PURE__*/_react["default"].createElement(_styles.StyledTitleRow, {
    isCollapsed: isCollapsed
  }, /*#__PURE__*/_react["default"].createElement(MobileTitle, {
    isCollapsed: isCollapsed,
    $isMobile: isMobile
  }, title));
  var UncollapsedMobileCancellationPolicy = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, TitleRow), currentReturnType !== 'nothing' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MobileDescription, {
    isMobilePopupComponent: isMobilePopupComponent
  }, isHotelOnly ? descriptionReturnType : description), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_styles.StyledStagesWrapper, {
    isMobile: true
  }, intervalledStages.map(function (stage, idx, array) {
    var _array;
    return /*#__PURE__*/_react["default"].createElement(_CancellationPolicyStage["default"], (0, _extends2["default"])({
      key: stage.start_date
    }, stage, {
      cancellationDateISO: cancellationDateISO,
      mobile: true,
      firstWidest: stage.hasNowDate,
      secondWidest: (_array = array[idx - 1]) === null || _array === void 0 ? void 0 : _array.hasNowDate,
      last: stages.length > 1 && idx === stages.length - 1,
      color: gradient[idx],
      progress: stage.progress,
      cancelled: cancelled,
      firstStage: idx === 0,
      isHotelOnly: isHotelOnly
    }));
  })), /*#__PURE__*/_react["default"].createElement(StyledStageList, {
    isMobilePopupComponent: isMobilePopupComponent
  }, intervalledStages.map(function (stage, idx) {
    return /*#__PURE__*/_react["default"].createElement(_CancellationStageListItem["default"], {
      key: stage.start_date,
      interval: stage.interval,
      price: stage.refund_amount,
      returnType: stage.return_type,
      flightDateISO: flightDateISO,
      first: idx === 0,
      isHotelOnly: isHotelOnly,
      isMobilePopupComponent: isMobilePopupComponent
    });
  }), hasTooltip ? /*#__PURE__*/_react["default"].createElement(StyledTooltipText, null, tooltipText) : null))) : /*#__PURE__*/_react["default"].createElement(StyledNothingStages, {
    isMobilePopupComponent: isMobilePopupComponent
  }, _localization.i18n.t('cancellationPolicy.collapsedDescription.nothing_hotel')));
  var CollapsedCancellationPolicyWithProps = /*#__PURE__*/_react["default"].createElement(_CollapsedCancellationPolicy["default"], {
    returnType: currentReturnType,
    isMobile: true,
    isHotelOnly: isHotelOnly,
    flightDateISO: flightDateISO,
    currentStageEndDateISO: currentStage === null || currentStage === void 0 ? void 0 : currentStage.interval.endDateISO,
    hasInsurance: hasInsurance,
    insurancePrice: insurancePrice,
    insuranceSelected: insuranceSelected,
    onGetInsuranceClick: onGetInsuranceClick,
    onDetailsClick: onDetailsClick,
    isCollapsed: isCollapsed,
    isSmall: !showBackground,
    cancelled: cancelled,
    mobileCollapsedElRef: mobileCollapsedElRef
  });
  return !showBackground && isCollapsed ? CollapsedCancellationPolicyWithProps : /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicyMobile, {
    className: className
  }, isCollapsed ? CollapsedCancellationPolicyWithProps : UncollapsedMobileCancellationPolicy);
};
var StyledStageList = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyMobile__StyledStageList",
  componentId: "sc-1kvtxny-0"
})(["display:flex;flex-direction:column;overflow:auto;", ""], function (_ref) {
  var isMobilePopupComponent = _ref.isMobilePopupComponent;
  return isMobilePopupComponent && "\n    background-color: #F5F3F2;\n    margin-top: 8px;\n    border-radius: 4px;\n    padding: 0px 16px 16px;\n    ";
});
var StyledCancellationPolicyMobile = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyMobile__StyledCancellationPolicyMobile",
  componentId: "sc-1kvtxny-1"
})(["display:flex;flex-direction:column;width:100%;overflow-x:hidden;overflow-y:auto;background-color:var(--white);border-radius:var(--border-radius);padding:8px;"]);

// Надо обновиться до styled-components ^5.0
// https://github.com/microsoft/TypeScript/issues/37597
// @ts-ignore
var MobileDescription = (0, _styledComponents["default"])(_styles.StyledDescription).withConfig({
  displayName: "CancellationPolicyMobile__MobileDescription",
  componentId: "sc-1kvtxny-2"
})(["margin:8px 0px 0px 0px;text-align:justify;color:#919499;", ""], function (_ref2) {
  var isMobilePopupComponent = _ref2.isMobilePopupComponent;
  return !isMobilePopupComponent && 'font-size: 12px;';
});
var MobileTitle = (0, _styledComponents["default"])(_styles.StyledTitle).withConfig({
  displayName: "CancellationPolicyMobile__MobileTitle",
  componentId: "sc-1kvtxny-3"
})(["display:inline;", ";color:var(--black);font-size:", ";font-style:normal;font-weight:500;"], function (props) {
  return props.isCollapsed ? 'padding-left: 11px' : null;
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile ? '18px' : '16px';
});
var StyledTooltipText = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyMobile__StyledTooltipText",
  componentId: "sc-1kvtxny-4"
})(["margin-top:8px;color:#919499;"]);
var StyledNothingStages = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyMobile__StyledNothingStages",
  componentId: "sc-1kvtxny-5"
})(["margin-top:8px;color:var(--black);", ""], function (_ref4) {
  var isMobilePopupComponent = _ref4.isMobilePopupComponent;
  return !isMobilePopupComponent ? 'font-size: 12px;' : 'font-size: 16px;';
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CancellationPolicyMobile);